/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Premsagar Choudhary <premsagar.choudhary@mroads.com>, July 2023
 * @format
 * @flow
 */

import MAPI from "../requests/mapiRequests";
import { dispatchLabelsAction, dispatchThemeUpdateAction } from "../store";
import tmsDefaultLabels from '../screens/WaitList/labels';

const StyleSheetId = 'OneDineThemingStyleSheet';

class CustomizationUtil {
  static updateTheme = (styleUrl) => {
    CustomizationUtil.removeTheme();
    try {
      if (styleUrl) {
        const css = document.createElement('link');
        css.type = 'text/css';
        css.id = StyleSheetId;
        css.href = `${styleUrl}?date=${new Date()}`;
        css.rel = 'stylesheet';
        document.getElementsByTagName('head')[0].appendChild(css);
      }
    } catch (err) {
      console.error(`error in appending stylesheet url - ${err}`);
    }
  };

  static removeTheme = () => {
    try {
      const prevStyleSheet = document.getElementById(StyleSheetId);
      if (prevStyleSheet) {
        prevStyleSheet.parentNode.removeChild(prevStyleSheet);
      }
    } catch (error) {
      console.error(`error in remove stylesheet url - ${error}`);
    }
  };

  static getCustomizeWaitlist = async (brandId, languageId, callback) => {
    try {
      const response = await MAPI.getCustomizeWaitlist(brandId, languageId);
      const customizeData = response.data;
      const parsedAppCustomization = JSON.parse(customizeData.appCustomization);
      const labels = { ...tmsDefaultLabels, ...parsedAppCustomization?.label };
      //update labels
      dispatchLabelsAction(labels);
      //updating theme
      dispatchThemeUpdateAction(CustomizationUtil.getWaitlistTheme(customizeData?.style));
      callback && callback();
    } catch (error) {
      console.error(`error in getCustomizeWaitlist() method - ${error}`);
    }
  };

  static getWaitlistTheme = (customizeStyle) => {
    let style = {};
    try {
      style = JSON.parse(customizeStyle);
    } catch (err) {
      console.error(err);
    }
    return {
      tmsMenu: {
        menuBackgroundColor: style?.['od-tmsMenu-menu-background-color']?.color || '#F6F6FB',
        menuIconColor: style?.['od-tmsMenu-menu-icon-color']?.color || '#000000',
        menuLabelColor: style?.['od-tmsMenu-menu-label-color']?.color || '#000000',
        backIconColor: style?.['od-tmsMenu-back-icon-color']?.color || '#0060FF',
      },
      createWaitList: {
        backgroundColor: style?.['od-createWaitList-background-color']?.color || '#FFFFFF',
        headerBackgroundColor: style?.['od-createWaitList-header-background-color']?.color || '#EFEFEF',
        closeIconColor: style?.['od-createWaitList-close-icon-color']?.color || '#1C1B1F',
        textColor: style?.['od-createWaitList-text-color']?.color || '#000',
        inputBorderColor: style?.['od-createWaitList-input-border-color']?.color || '#A6A6A6',
        inputTextColor: style?.['od-createWaitList-input-text-color']?.color || '#000',
        primaryButtonBackgroundColor: style?.['od-createWaitList-primary-button-background-color']?.color || '#0060FF',
        primaryButtonTextColor: style?.['od-createWaitList-primary-button-text-color']?.color || '#fff',
        secondaryButtonBackgroundColor: style?.['od-createWaitList-secondary-button-background-color']?.color || '#fff',
        secondaryButtonTextColor: style?.['od-createWaitList-secondary-button-text-color']?.color || '#0060FF',
        secondaryButtonBorderColor: style?.['od-createWaitList-secondary-button-border-color']?.color || '#0060FF',
      },
      assignTable: {
        backgroundColor: style?.['od-assignTable-background-color']?.color || '#FFFFFF',
        headerBackgroundColor: style?.['od-assignTable-header-background-color']?.color || '#EFEFEF',
        closeIconColor: style?.['od-assignTable-close-icon-color']?.color || '#1C1B1F',
        textColor: style?.['od-assignTable-text-color']?.color || '#000',
        primaryButtonBackgroundColor: style?.['od-assignTable-primary-button-background-color']?.color || '#0060FF',
        primaryButtonTextColor: style?.['od-assignTable-primary-button-text-color']?.color || '#fff',
        secondaryButtonBackgroundColor: style?.['od-assignTable-secondary-button-background-color']?.color || '#fff',
        secondaryButtonTextColor: style?.['od-assignTable-secondary-button-text-color']?.color || '#0060FF',
        secondaryButtonBorderColor: style?.['od-assignTable-secondary-button-border-color']?.color || '#0060FF',
        guestBackground: style?.['od-assignTable-guest-background']?.color || '#F0F0F0',
        guestHeaderColor: style?.['od-assignTable-guest-header-color']?.color || '#000',
        guestLabelColor: style?.['od-assignTable-guest-label-color']?.color || '#7E7E7E',
        guestValueColor: style?.['od-assignTable-guest-value-color']?.color || '#000',
        partySizeBackgroundColor: style?.['od-assignTable-party-size-background-color']?.color || '#7E7E7E',
        partySizeTextColor: style?.['od-assignTable-party-size-text-color']?.color || '#fff',
        tableCardBackground: style?.['od-assignTable-table-card-background']?.color || '#F7F7F7',
        tableTextColor: style?.['od-assignTable-table-text-color']?.color || 'rgba(0, 0, 0, 0.89)',
        tableBorderColor: style?.['od-assignTable-table-border-color']?.color || '#B3B3B3',
        selectedTableCardBackground: style?.['od-assignTable-selected-table-card-background']?.color || '#9EBEFB',
      },
      employeeLookup: {
        serverCardBackground: style?.['od-employeeLookup-server-card-background']?.color || '#EFEED1',
        serverTextColor: style?.['od-employeeLookup-server-text-color']?.color || '#000000',
        textColor: style?.['od-employeeLookup-text-color']?.color || '#000',
        optional: style?.['od-employeeLookup-optional']?.color || '#7E7E7E',
        selectedBorder: style?.['od-employeeLookup-selected-border']?.color || '#00008B',
      },
      waitList: {
        backgroundColor: style?.['od-waitList-background-color']?.color || '#1E1E1E',
        iconColor: style?.['od-waitList-icon-color']?.color || '#FFFFFF',
        textColor: style?.['od-waitList-text-color']?.color || '#FFFFFF',
        borderColor: style?.['od-waitList-border-color']?.color || '#79747E',
        cardBackgroundColor: style?.['od-waitList-card-background-color']?.color || '#282829',
        actionButtonBackgroundColor: style?.['od-waitList-action-button-background-color']?.color || '#534C63',
        notesBackgroundColor: style?.['od-waitList-notes-background-color']?.color || '#4A4949',
        noteIconColor: style?.['od-waitList-note-icon-color']?.color || '#8FB9FF',
        partySizeBackgroundColor: style?.['od-waitList-party-size-background-color']?.color || '#717171',
        primaryButtonBackgroundColor: style?.['od-waitList-primary-button-background-color']?.color || '#0060FF',
        primaryButtonTextColor: style?.['od-waitList-primary-button-text-color']?.color || '#FFFFFF',
        secondaryButtonBackgroundColor: style?.['od-waitList-secondary-button-background-color']?.color || '#9EBEFB',
        secondaryButtonTextColor: style?.['od-waitList-secondary-button-text-color']?.color || '#000000',
        secondaryButtonBorderColor: style?.['od-waitList-secondary-button-border-color']?.color || '#79747E',
      },
      tableProperties: {
        headerBackgroundColor: style?.['od-tableProperties-header-background-color']?.color || '#DFEFFF',
        textColor: style?.['od-tableProperties-text-color']?.color || '#000',
        closeIconColor: style?.['od-tableProperties-close-icon-color']?.color || '#1F529C',
        actionsBackground: style?.['od-tableProperties-actions-background']?.color || '#F6F6F6',
        tableNumberTextColor: style?.['od-tableProperties-table-number-text-color']?.color || '#000',
        checkTextColor: style?.['od-tableProperties-check-text-color']?.color || '#000',
        message: style?.['od-tableProperties-message']?.color || '#000',
        primaryButtonBackgroundColor: style?.['od-tableProperties-primary-button-background-color']?.color || '#0060FF',
        primaryButtonTextColor: style?.['od-tableProperties-primary-button-text-color']?.color || '#fff',
        secondaryButtonBackgroundColor: style?.['od-tableProperties-secondary-button-background-color']?.color || '#fff',
        secondaryButtonTextColor: style?.['od-tableProperties-secondary-button-text-color']?.color || '#0060FF',
        secondaryButtonBorderColor: style?.['od-tableProperties-secondary-button-border-color']?.color || '#0060FF',
        tabsContainerBackgroundColor: style?.['od-tableProperties-tabs-container-background-color']?.color || '#F6F6F6',
        tabsBackgroundColor: style?.['od-tableProperties-tabs-background-color']?.color || '#a3a3a3',
        actionButtonBorderColor: style?.['od-tableProperties-action-button-border-color']?.color || 'rgba(0, 0, 0, 0.89)',
        selectedActionBackgroundColor: style?.['od-tableProperties-selected-action-background-color']?.color || '#9EBEFB',
        selectedActionBorderColor: style?.['od-tableProperties-selected-action-border-color']?.color || '#9EBEFB',
      },
      mergeTable: {
        tableCardBackground: style?.['od-mergeTable-table-card-background-color']?.color || '#F7F7F7',
        tableTextColor: style?.['od-mergeTable-table-text-color']?.color || '#000000',
        textColor: style?.['od-mergeTable-text-color']?.color || '#000',
        tableBorderColor: style?.['od-mergeTable-table-border-color']?.color || '#B3B3B3',
        selectedTableCardBackground: style?.['od-mergeTable-selected-table-card-background']?.color || '#9EBEFB',
        selectedTableBorderColor: style?.['od-mergeTable-selected-table-border-color']?.color || '#00008B',
      },
      helpPopup: {
        headerBackgroundColor: style?.['od-helpPopup-header-background-color']?.color || '#DFEFFF',
        headerTextColor: style?.['od-helpPopup-header-text-color']?.color || 'rgba(0, 0, 0, 0.89)',
        closeIconColor: style?.['od-helpPopup-close-icon-color']?.color || '#1F529C',
        textColor: style?.['od-helpPopup-text-color']?.color || 'rgba(0, 0, 0, 0.89)',
      },
      checklookup: {
        headerBackgroundColor: style?.['od-checkLookup-header-background-color']?.color || '#DFEFFF',
        headerTextColor: style?.['od-checkLookup-header-text-color']?.color || 'rgba(0, 0, 0, 0.89)',
        closeIconColor: style?.['od-checkLookup-close-icon-color']?.color || '#1F529C',
        primaryButtonBackgroundColor: style?.['od-checkLookup-primary-button-background-color']?.color || '#0060FF',
        primaryButtonTextColor: style?.['od-checkLookup-primary-button-text-color']?.color || '#fff',
        secondaryButtonBorderColor: style?.['od-checkLookup-secondary-button-border-color']?.color || '#0060FF',
        secondaryButtonTextColor: style?.['od-checkLookup-secondary-button-text-color']?.color || '#0060FF',
      },
      snackbar: {
        backgroundColor: style?.['od-snackBar-background-color']?.color || '#fff',
        color: style?.['od-snackBar-color']?.color || 'rgba(0, 0, 0, 0.89)',
      },
      checkDetails: {
        menuItemColor: style?.['od-checkDetails-menu-item-color']?.color || '#000',
        menuItemPriceColor: style?.['od-checkDetails-menu-item-price-color']?.color || '#000',
        modifierColor: style?.['od-checkDetails-modifier-color']?.color || '#000',
        modifierPriceColor: style?.['od-checkDetails-modifier-price-color']?.color || '#000',
        checkItemBorderColor: style?.['od-checkDetails-check-item-border-color']?.color || '#898989',
        pendingColor: style?.['od-checkDetails-pending-color']?.color || '#AD002850',
        commentColor: style?.['od-checkDetails-comment-color']?.color || '#000',
        modifierCommentColor: style?.['od-checkDetails-modifier-comment-color']?.color || '#000',
        discountColor: style?.['od-checkDetails-discount-color']?.color || '#000',
        paymentLabelColor: style?.['od-checkDetails-payment-label-color']?.color || '#000',
        amountLabel: style?.['od-checkDetails-amount-label']?.color || '#000',
        amountValue: style?.['od-checkDetails-amount-value']?.color || '#000',
      },
      aboutPopup: {
        headerBackgroundColor: style?.['od-aboutPopup-header-background-color']?.color || '#DFEFFF',
        headerTextColor: style?.['od-aboutPopup-header-text-color']?.color || 'rgba(0, 0, 0, 0.89)',
        closeIconColor: style?.['od-aboutPopup-close-icon-color']?.color || '#1F529C',
        primaryTextColor: style?.['od-aboutPopup-primary-text-color']?.color || 'rgba(0, 0, 0, 0.89)',
        secondaryTextColor: style?.['od-aboutPopup-secondary-text-color']?.color || '#7E7E7E',
      },
      designer: {
        headerBackgroundColor: style?.['od-designer-header-background-color']?.color || '#DFEFFF',
        headerIconColor: style?.['od-designer-header-icon-color']?.color || '#1F529C',
        propertyBackgroundColor: style?.['od-designer-property-background-color']?.color || '#F0F0F0',
        inputBackgroundColor: style?.['od-designer-input-background-color']?.color || '#ffffff',
        inputTextColor: style?.['od-designer-input-text-color']?.color || '#7E7E7E',
        inputBorderColor: style?.['od-designer-input-border-color']?.color || '#7E7E7E',
        inputLabelColor: style?.['od-designer-input-label-color']?.color || '#2C2C2C',
        textColor: style?.['od-designer-text-color']?.color || 'rgba(0, 0, 0, 0.89)',
        actionButtonBackgroundColor: style?.['od-designer-action-button-background-color']?.color || '#CDDFF9',
        toolBackgroundColor: style?.['od-designer-tool-background-color']?.color || '#F8F8F8',
        toolIconColor: style?.['od-designer-tool-icon-color']?.color || '#9EBEFB',
        selectedToolBackgroundColor: (style?.['od-designer-selected-tool-background-color']?.color || '#9EBEFB') + ' !important',
        selectedToolIconColor: style?.['od-designer-selected-tool-icon-color']?.color || 'rgba(0, 0, 0, 0.89)',
        toolBorderColor: style?.['od-designer-tool-border-color']?.color || '#534C63',
        placeholderTitleColor: style?.['od-designer-placeholder-title-color']?.color || '#7E7E7E',
        primaryButtonBackgroundColor: style?.['od-designer-primary-button-background-color']?.color || '#0060FF',
        primaryButtonTextColor: style?.['od-designer-primary-button-text-color']?.color || '#FFFFFF',
        primaryButtonBorderColor: style?.['od-designer-primary-button-border-color']?.color || '#0060FF',
        secondaryButtonBackgroundColor: style?.['od-designer-secondary-button-background-color']?.color || '#FFFFFF',
        secondaryButtonTextColor: style?.['od-designer-secondary-button-text-color']?.color || '#0060FF',
        secondaryButtonBorderColor: style?.['od-designer-secondary-button-border-color']?.color || '#0060FF',
      },
      confirmationPopup: {
        backgroundColor: '#ffffff',
        backdropBackgroundColor: '#FFFFFF99',
        borderColor: '#CBCBCB',
        titleColor: '#2C2C2C',
        textColor: 'rgba(0, 0, 0, 0.89)',
        primaryButtonBackgroundColor: '#0060FF',
        primaryButtonTextColor: '#FFFFFF',
        primaryButtonBorderColor: '#0060FF',
        secondaryButtonBackgroundColor: '#FFFFFF',
        secondaryButtonTextColor: '#0060FF',
        secondaryButtonBorderColor: '#0060FF',
      },
    };
  };
}

export default CustomizationUtil;